import styled from "styled-components";
import { type SpaceProps, type BordersProps, space, borders } from "styled-system";
import { theme } from "../../../../../../../styles/v2/lexus/theme/lexusTheme";
import { listItemStyle } from "../../../../../../../styles/v2/lexus/globals/Type";

export const Wrapper = styled.div<SpaceProps & BordersProps>`
    display: flex;
    justify-content: space-between;
    user-select: none;
    ${listItemStyle};
    ${space};
    ${borders};
`;

export const Min = styled.div`
    padding-right: 6px;

    html[dir="rtl"] & {
        padding-left: 6px;
        padding-right: 0;
    }
`;

export const Max = styled.div`
    padding-left: 6px;
    text-align: end;

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 6px;
    }
`;

export const Title = styled.div``;

export const Subtitle = styled.div`
    color: ${theme.colors.azure};
    ${listItemStyle};
`;
